// extracted by mini-css-extract-plugin
module.exports = {"title":"HRECtV9fdcPtyN8WMAzdxw==","date":"y5J8iGPwPCPxS+5JmlbJoA==","annotationIcon":"JN1j72FBqC0XJxO+YNhq2w==","subHeader":"_5OQD9+JHeuhbKn6SVD4HLg=="};